import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-testid": "fleet-values-from-loading"
}
const _hoisted_2 = { class: "text-label ml-10" }
const _hoisted_3 = {
  key: 1,
  class: "values-from-container",
  "data-testid": "fleet-values-from-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValueFromResource = _resolveComponent("ValueFromResource")!
  const _component_RcButton = _resolveComponent("RcButton")!
  const _directive_t = _resolveDirective("t")!

  return (!$data.allConfigMaps || !$data.allSecrets)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon icon-lg icon-spinner icon-spin" }, null, -1)),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.t('fleet.helmOp.values.valuesFrom.loading')), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(!$props.compact ? 'h2' : 'h4'), { class: "m-0" }, null, 512)), [
          [_directive_t, 'fleet.helmOp.values.valuesFrom.selectLabel']
        ]),
        _cache[3] || (_cache[3] = _createTextVNode()),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.valuesFrom, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            key: row.id + '-' + row?.valueFrom?.configMapKeyRef?.key + '-' + row?.valueFrom?.secretKeyRef?.key,
            class: "mmt-4"
          }, [
            _createVNode(_component_ValueFromResource, {
              "data-testid": `fleet-values-from-item-${ row.id }`,
              value: row,
              options: $options.valueFromOptions,
              "all-secrets": $data.allSecrets,
              "all-config-maps": $data.allConfigMaps,
              namespaced: true,
              mode: $props.mode,
              "show-variable-name": true,
              onRemove: ($event: any) => ($options.removeValueFrom(row.id)),
              "onUpdate:value": ($event: any) => ($options.updateValueFrom(row.id, $event))
            }, null, 8, ["data-testid", "value", "options", "all-secrets", "all-config-maps", "mode", "onRemove", "onUpdate:value"])
          ]))
        }), 128)),
        _cache[4] || (_cache[4] = _createTextVNode()),
        (!$options.isView)
          ? (_openBlock(), _createBlock(_component_RcButton, {
              key: 0,
              ref: "add-button",
              size: "small",
              variant: "secondary",
              class: "mmt-6",
              "data-testid": "fleet-values-from-add",
              onClick: $options.addValueFrom
            }, {
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon icon-plus" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.t('workload.container.command.addEnvVar')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]))
}